import React from 'react';
import { Box, Typography, Table, Checkbox, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';
import { StyledTableCell } from '../../style';
import StyleTextField from '../../styleTextField';

const SmartFilteringTags = ({ isSmartFilteringEnabled, smartFiltering, smartFilteringErrors, handleSmartFilteringInputChange, setIsSmartFilteringEnabled }) => (
    <>
        <Table>
            <StyledTableCell sx={{ padding: '12px 12px', width: '100%' }} colSpan={3}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Tooltip
                        title={
                            <>
                                <Typography variant="body2" sx={{ fontSize: '12px' }}>
                                    Optimizes image size and standardizes formats to enable faster processing and improve model performance.{' '}
                                </Typography>
                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '4px', fontWeight: '600' }}>
                                    Use this only when the dataset contains images larger than 3 MB.
                                </Typography>
                            </>
                        }
                        arrow
                        placement="top-end"
                    >
                        <Typography
                            sx={{
                                marginRight: '10px',
                                fontSize: '16px',
                                color: '#0047BA',
                                fontWeight: '500',
                            }}
                        >
                            Enable Smart Filtering
                            <Checkbox
                                size="small"
                                color="primary"
                                checked={isSmartFilteringEnabled}
                                onChange={(e) => setIsSmartFilteringEnabled(e.target.checked)}
                            />
                        </Typography>
                    </Tooltip>
                </Box>
            </StyledTableCell>
        </Table>
        {isSmartFilteringEnabled &&
            smartFiltering?.map((row, index) => {
                const hasAnyValue = smartFiltering.some((tag) => tag.mvalue.trim() !== '');
                const isRequired = hasAnyValue;

                return (
                    <Table key={`smart-${index}`} sx={{ height: '40px' }}>
                        <StyledTableCell sx={{ width: '40px', padding: '12px 12px' }} />
                        <StyledTableCell sx={{ padding: '12px 12px', width: '200px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {isRequired && <Typography sx={{ color: '#E4080A', marginRight: '4px' }}>*</Typography>}
                                {row.name}
                                {row.tooltipInfo && (
                                    <Tooltip
                                        title={row.tooltipInfo}
                                        arrow
                                        componentsProps={{
                                            tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                                            arrow: { sx: { color: '#272727' } },
                                        }}
                                    >
                                        <InfoOutlinedIcon
                                            sx={{
                                                fontSize: '16px',
                                                color: '#005CBC',
                                                marginLeft: '8px',
                                                cursor: 'pointer',
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            </Box>
                        </StyledTableCell>
                        <StyledTableCell sx={{ padding: '12px 12px', width: '100px' }}>
                            <StyleTextField
                                value={row.mvalue}
                                onChange={(e) => handleSmartFilteringInputChange(index, 'mvalue', e.target.value)}
                                variant="filled"
                                sx={{
                                    '&.MuiTextField-root': {
                                        border: 'none',
                                    },
                                    width: '500px',
                                    border: `1px solid ${smartFilteringErrors[index] ? '#d40020' : '#1378D4'}`,
                                    opacity: isSmartFilteringEnabled ? 1 : 0.6,
                                }}
                                inputProps={{
                                    style: { padding: '4px' },
                                }}
                                disabled={!isSmartFilteringEnabled}
                            />
                            {smartFilteringErrors[index] && (
                                <Typography sx={{ color: '#d40020', fontSize: '12px', marginTop: '4px' }}>{smartFilteringErrors[index]}</Typography>
                            )}
                            <Typography sx={{ fontSize: '10px', color: 'grey', mt: '4px' }}>{row.helpText}</Typography>
                        </StyledTableCell>
                    </Table>
                );
            })}
    </>
);

SmartFilteringTags.propTypes = {
    isSmartFilteringEnabled: PropTypes.bool.isRequired,
    smartFiltering: PropTypes.array.isRequired,
    smartFilteringErrors: PropTypes.object.isRequired,
    handleSmartFilteringInputChange: PropTypes.func.isRequired,
    setIsSmartFilteringEnabled: PropTypes.func.isRequired,
};

export default SmartFilteringTags;
